<template>
  <div class="gh-list-item__head">
    <div class="gh-list-item__head-left">
      <span v-if="serviceNameKey" class="gh-list-item__service">{{ $t(serviceNameKey) }}</span>
      <span v-if="projectName" class="gh-list-item__project">{{ projectName }}</span>
    </div>
    <span class="gh-list-item__datetime">{{ formattedDatetime }}</span>
  </div>
</template>

<script>
import { dateFormatted } from '@/shared/filters';

const DATETIME_FORMAT = 'YYYY/MM/DD HH:mm';

export default {
  name: 'GenerationHistoryListItemHead',
  props: {
    serviceNameKey: {
      type: String,
      default: null,
    },
    projectName: {
      type: String,
      default: '',
    },
    datetime: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    formattedDatetime() {
      return dateFormatted(this.datetime, DATETIME_FORMAT);
    },
  },
};
</script>
